import {updateFactory} from '@modifi/redux'
import {aUpdateLocalUserSettings, aFetchUserSettings} from './entity'
import {getAuthenticatedShipmentsClient, UserSettingView} from '../../lib'
import {NestedError} from '../../utils'

const apiClient = getAuthenticatedShipmentsClient()

const {reducer, actions} = updateFactory({
  rootSelector: state => state?.data?.userSettings?.update,
  actionNamePrefix: 'data/user-settings/update',
  submitRequest:
    (a, data: UserSettingView) =>
    async (dispatch): Promise<void> => {
      dispatch(a.pendingAction())

      try {
        dispatch(aUpdateLocalUserSettings(data))
        await apiClient.UserSettings.update({
          body: data,
        })
        dispatch(a.successAction())
      } catch (e: any) {
        dispatch(a.errorAction(e))
        throw new NestedError('Error while calling UserSettings.update', e)
      } finally {
        dispatch(aFetchUserSettings())
      }
    },
})

export default reducer

export const {aSubmit: aUpdateUserSettings} = actions
